/** @format */

import { memo } from 'react'
import { CopyBlock, shadesOfPurple } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _2 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>2 - CSS-градиент</h2>
    <p className={styles.description}>
      <b>Градиент</b> - переход от одного цвета к другому. В CSS градиент может быть линейный или радиальный. Градиент
      для фона элемента можно устанавливать в свойствах: <code className={styles.code}>background</code> и{' '}
      <code className={styles.code}>background-image</code>.
    </p>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>2.1 - Линейный градиент</h3>
      <p className={styles.description}>
        Линейный градиент создается с помощью двух и более цветов, для которых задано направление распределения. Если
        направление не указано, используется значение по умолчанию — сверху-вниз{' '}
        <code className={styles.code}>to bottom</code>.{' '}
      </p>
      <CopyBlock
        text="background-image: linear-gradient(#0B486B, #F56217);"
        language="css"
        showLineNumbers
        theme={shadesOfPurple}
      />
      <div className={styles.gradient__simple} />
      <p className={styles.description}>Направление градиента может быть задано двумя способами:</p>
      <ul className={styles.list}>
        <li className={styles.list__item}>С помощью угла наклона в градусах deg.</li>
        <li className={styles.list__item}>С помощью ключевых слов to top, to right, to bottom, to left</li>
      </ul>
      <CopyBlock
        text="background-image: linear-gradient(to right, #0B486B, #F56217);"
        language="css"
        showLineNumbers
        theme={shadesOfPurple}
      />
      <div className={styles.gradient__to_right} />
      <p className={styles.description}>
        Если направление задано парой ключевых слов, например, to bottom left, то начальная точка градиента будет
        расположена в противоположном углу.{' '}
      </p>
      <CopyBlock
        text="background-image: linear-gradient(to bottom left, #0B486B, #F56217);"
        language="css"
        showLineNumbers
        theme={shadesOfPurple}
      />
      <div className={styles.gradient__to_bottom_left} />
      <p className={styles.description}>
        При создании грдиента можно использовать сколько угодно цветов, в таком случае необходимо указывать точки до
        которых будет распространяться определенный цвет.{' '}
      </p>
      <CopyBlock
        text="background-image: linear-gradient(to right, #0B486B 15%, #F56217 35%, #F11712 65%, #0099F7);"
        language="css"
        showLineNumbers
        theme={shadesOfPurple}
      />
      <div className={styles.gradient__to_right_colors} />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>2.2 - Радиальный градиент</h3>
      <p className={styles.description}>
        Радиальный градиент отличается от линейного тем, что цвета выходят изцентра градиента и равномерно
        распределяются наружу, принимая форму окружности.
      </p>
      <p className={styles.description}>
        Форма градиента определяется ключевыми словами <code className={styles.code}>circle</code> или{' '}
        <code className={styles.code}>ellipse</code> (значение по умолчанию).
      </p>
      <p className={styles.description}>
        Позиция центра задаётся с помощью ключевых слов с добавлением приставки at. Значение по умолчанию{' '}
        <code className={styles.code}>at center</code> .
      </p>
      <CopyBlock
        text="background-image: radial-gradient(circle at center, #1488CC, #b31217);"
        language="css"
        showLineNumbers
        theme={shadesOfPurple}
      />
      <div className={styles.gradient__circle_at_center} />
      <p className={styles.description}>
        Подборка интересных градиентов -{' '}
        <a className={styles.link} href="https://uigradients.com/#Reaqua" target="_blank" rel="noopener noreferrer">
          uigradients.com
        </a>
      </p>
    </section>
  </section>
))
